// Campus photo for /colleges/california-polytechnic-state-university-san-luis-obispo: CC BY-SA 4.0, by Stilfehler, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ARobert_E._Kennedy_Library%2C_exterior%2C_Cal_Poly_SLO_(September_2018).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/california-polytechnic-state-university-san-luis-obispo/; credited under the photo.
const photo = {
    "slug": "california-polytechnic-state-university-san-luis-obispo",
    "alt": "The Robert E. Kennedy Library above a lawn and stairs at Cal Poly in San Luis Obispo, California",
    "src": "/colleges/california-polytechnic-state-university-san-luis-obispo/campus-1600.webp",
    "srcSmall": "/colleges/california-polytechnic-state-university-san-luis-obispo/campus-800.webp",
    "srcMid": "/colleges/california-polytechnic-state-university-san-luis-obispo/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/california-polytechnic-state-university-san-luis-obispo/og.jpg",
    "title": "Robert E. Kennedy Library, exterior, Cal Poly SLO (September 2018)",
    "author": "Stilfehler",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ARobert_E._Kennedy_Library%2C_exterior%2C_Cal_Poly_SLO_(September_2018).jpg",
    "read": "2026-10-01"
};

export default photo;
